"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.payments = void 0;
const _payments = __importStar(require("./payments"));
const app_1 = require("../app");
function payments(stripe, firebaseApp) {
    if (!firebaseApp) {
        firebaseApp = app_1.app.firebase.app();
    }
    return new _payments.Payments(stripe, firebaseApp);
}
exports.payments = payments;
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (payments) {
    payments.Payments = _payments.Payments;
})(payments = exports.payments || (exports.payments = {}));
//# sourceMappingURL=index.js.map